import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=23134f96&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=23134f96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23134f96",
  null
  
)

export default component.exports